import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';
import type { components } from '@/shared/api/openapi';

type Organization = components['schemas']['GetOrganizationsAutoCompleteEndpoint_Response'];

interface UseOrganizationsAutocompleteOptions {
  filter: string;
  limit?: number;
  enabled?: boolean;
}

export function useOrganizationsAutocomplete({ filter, limit = 50, enabled = true }: UseOrganizationsAutocompleteOptions) {
  const { getAccessToken } = useAuth();

  const shouldFetch = enabled && filter.length >= 3;

  return useQuery({
    queryKey: ['organizationsAutocomplete', filter, limit],
    queryFn: async () => {
      const client = createApiClient(getAccessToken);
      const { data, error } = await client.GET('/api/organizations/autocomplete', {
        params: {
          query: {
            Filter: filter,
            Limit: limit,
          },
        },
      });

      if (error) {
        throw new Error('Failed to fetch organizations');
      }

      return (data as Organization[]) || [];
    },
    enabled: shouldFetch,
    staleTime: 30000,
  });
}
